module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "paypal-button-container"
    }
  }, [(!_vm.ready) ? _c('div', {
    attrs: {
      "id": "loadingButtonCreditCard"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v("\n    Preparando...\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38beafa8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paypal-credit-card.vue
// module id = 406
// module chunks = 1